export default "__VITE_ASSET__c1af7d2d__"